// SHIM — codice spostato in src/shared/msp/api.js
export { default, _api, URLparams } from '@shared/msp/api.js';
